module.exports = __webpack_public_path__ + "static/img/design-1.8893094e.png";